import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IChangePasswordPayload {
    password: any
    cognitoUser: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface IChangePasswordState {
    status: string
    data: {
        token: string
    }
    errors: any
}

const initialState: IChangePasswordState = {
    status: STATUS.IDLE,
    data: {
        token: ''
    },
    errors: null
}

const changePasswordSlice = createSlice({
    name: 'auth/change-password',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IChangePasswordPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data.token = action.payload.token
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const changePasswordActions = changePasswordSlice.actions
export default changePasswordSlice.reducer
